import * as React from "react";

import { Button } from "@common/components/Button";
import { Flex } from "@common/components/Flex";
import "./body-name-cell.styles.scss";

type BodyNameCellProps = {
  item: { id: string | number; img: string };
  onClick?: (itemId: string | number) => void;
  label: string | number;
};

export const BodyNameCell: React.FC<BodyNameCellProps> = ({
  item,
  label,
  onClick,
}) => {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(item.id);
    }
  }, [onClick, item.id]);

  const safeLabel = label ?? "(No Name)";
  
  return (
    <div className="BodyNameCell">
      <Flex alignItems="center">
        <img
          src={item.img}
          className="BodyNameCell__gender-img"
          onClick={onClick ? handleClick : undefined}
        />
        <Button
          title={safeLabel.toString()}
          variant="text"
          onClick={onClick ? handleClick : undefined}
        >
          {safeLabel}
        </Button>
      </Flex>
    </div>
  );
};
